import React, {PropsWithChildren}    from 'react';
import ErrorBoundary                 from 'components/ErrorBoundary';
import muiThemeNew, {globalStyles}   from '../../config/muiThemeNew';
import ThemeProvider                 from '@mui/material/styles/ThemeProvider';
import GlobalStyles                  from '@mui/material/GlobalStyles';

export default function Secondary({ children }: PropsWithChildren) {
  return (
    <ThemeProvider theme={muiThemeNew}>
      <GlobalStyles styles={globalStyles} />
      <ErrorBoundary>{children}</ErrorBoundary>
    </ThemeProvider>
  )
}
